import RoleHome from '../RoleHome';

export default function RevenueOfficerPage() {
  return (
    <RoleHome
      title="Revenue officer"
      description="Revenue operations, billing read access, and analytics."
    />
  );
}
